const myBookingsES = {
	upcomingTitle: "Próximas",
	upcomingSubLoading: "Cargando...",
	upcomingSubCount: (count) => `${count} confirmadas`,
	noUpcoming: "No hay reservas próximas",
	emailSent: "Correo enviado",
	addToCalendar: "Añadir al Calendario",
	reschedule: "Reprogramar",
	cancel: "Cancelar",

	historyTitle: "Historial",
	historySub: "Tus visitas anteriores",
	noHistory: "Aún no hay visitas anteriores",

	table: {
		date: "Fecha",
		service: "Servicio",
		shop: "Negocio",
		status: "Estado",
	},
};

export default myBookingsES;
